export const environment = {
  production: true,
  backendApiUrl: 'https://api.qazaqpay.kz/api',
  //backendApiUrl: 'http://public.softclub.by:8086/api',
  locales: ['ru', 'kk'],
  defaultLocale: 'ru',
  project: "web-merchant"
};
